import {Props} from './model';
import {View, TouchableOpacity} from 'react-native';
import * as React from 'react';

import {Notification} from './components/notification';
import {useStyles} from '../../hooks/styles';
export default (props: Props) => {
  const styles = useStyles(() => ({
    container: {
      position: 'absolute',
      top: 50,
      left: 0,
      right: 0,
      alignItems: 'center',
      justifyContent: 'flex-start',
      zIndex: 101,
      pointerEvents: 'none',
      paddingHorizontal: 24,
    },
  }));
  return (
    <View testID='snackbar' style={styles.container}>
      {props.notifications.map((item) => {
        if (!item.onClick) {
          return <Notification key={item.id} notification={item} />;
        }
        return (
          <TouchableOpacity
            testID={`snackbar-${item.id}-id`}
            onPress={() => {
              item.onClick?.();
              props.onCloseAdditional(item.id);
            }}>
            <Notification key={item.id} notification={item} />
          </TouchableOpacity>
        );
      })}
    </View>
  );
};
